<app-otp-enlace [clave]="clave" (validado)="abrirFormulario($event)"></app-otp-enlace>
